

export const getTotalPrice = (sub) => sub.metered 
    ? sub.unitPrice * sub.currentUsage
    : sub.billingInterval === 'monthly' ? sub.unitPrice : sub.unitPrice * 12